._CampaignInviteButton_1l3es_1 {
  width: 170px;
}